/**
 * Source of truth for the main resource types.  This allows us to attach this to objects (since TS reflection sucks),
 * so we can identify the type of a resource without having to pass it down a long chain of functions.
 */
export const SplixerResourceTypes = {
  Station: 'Station',
  Channel: 'Channel',
  Host: 'Host',
  Program: 'Program',
  Show: 'Show',
  Segment: 'Segment',
  Mix: 'Mix',
  MediaTitle: 'MediaTitle',
  PlaybackLog: 'PlaybackLog',
  BrandedTag: 'BrandedTag',
  Listener: 'Listener',
  Instance: 'Instance',
  PlaybackSession: 'PlaybackSession',
  Post: 'Post'
} as const;

export type SplixerResourceType = typeof SplixerResourceTypes[keyof typeof SplixerResourceTypes];

export interface hasResourceType {
  resourceType: SplixerResourceType;
}
